import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useZakeke } from 'zakeke-configurator-react';

export interface LoaderProps {
  visible: boolean;
  loadingText?: string;
}

const ProgressBarLoadingBackground = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 12;
  background: rgba(255, 255, 255, 0.95);
  padding: 1rem;
`;

const ProgressBarLoadingContainer = styled.div`
  width: 100%;
  max-width: 650px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 766px) {
    max-width: 350px;
    padding: 16px;
  }
`;

const LoaderContainer = styled.div`
  height: 8px;
  width: 100%;
  max-width: 600px;
  border-radius: 4px;
  background: #eee;

  @media screen and (max-width: 766px) {
    max-width: 310px;
  }
`;

const LoaderFill = styled.div<{ completed?: number }>`
  height: 100%;
  border-radius: 4px;
  background-color: #000;
  width: ${({ completed }) => completed || 0}%;
  transition: width 0.2s ease;
`;

const LoadingPercentageandIconContainer = styled.div`
  display: flex;
  justify-content: start;
  margin-top: 4px;
`;

const LoadingPercentageLabel = styled.span`
  color: #8fa4ae;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  font-family: 'Inter';
`;

const Loader: React.FC<LoaderProps> = () => {
  const { isSceneLoading } = useZakeke();
  const [completed, setCompleted] = useState<number>(0);

  useEffect(() => {
    let currentProgress = 0;
    let step = 0.3;

    if (!isSceneLoading) {
      setCompleted(100);
    } else {
      const interval = setInterval(() => {
        currentProgress += step;
        setCompleted(
          Math.round((Math.atan(currentProgress / 2) / (Math.PI / 2)) * 100 * 100) / 100
        );
      }, 50);
      return () => clearInterval(interval);
    }
  }, [isSceneLoading]);

  return (
    <ProgressBarLoadingBackground>
      <ProgressBarLoadingContainer>
        <img
          width={200}
          height={200}
          src="./Suzi-Wong-Option3-200px.gif"
          alt="Loading..."
          loading="eager"
          className="loading-gif"
        />

        <LoaderContainer>
          <LoaderFill completed={isSceneLoading ? completed : 100} />
        </LoaderContainer>

        <LoadingPercentageandIconContainer>
          <LoadingPercentageLabel>
            {isSceneLoading ? `${completed}%` : '100%'}
          </LoadingPercentageLabel>
        </LoadingPercentageandIconContainer>
      </ProgressBarLoadingContainer>
    </ProgressBarLoadingBackground>
  );
};

export default Loader;
